import { symFor } from '../lib/categories'

/** A Field signals v2 mark (SYMBOLS.md) in the current text color. Decoration only: the label names the thing. */
export function Symbol({ cat, size = 40, className = '' }: { cat: string; size?: number; className?: string }) {
  const url = `/symbols/field-signals/${symFor(cat)}.svg`
  return <span aria-hidden="true" className={`sym ${className}`} style={{ width: size, height: size, ['--sym' as string]: `url("${url}")` }} />
}
